<template>
  <div style="width: 1200px; margin: 0 auto" @click="changeType('premiumFile')">
    <el-upload
        class="avatar-uploader premium-banner"
        :auto-upload="false"
        action=""
        :show-file-list="false"
        list-type="picture"
        :file-list="premiumFile"
        :on-change="onlyOneFileUpload"

    >
      <img v-if="hasFile(premiumFile)" :src="premiumFile[0].org_url" class="avatar">
      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      <button v-if="hasFile(premiumFile)"  @click.stop="deleteImage(premiumFile)" class="cancelBtn"></button>
    </el-upload>
    <el-button class="reg_btn_out big_btn mt20 float_right" @click="save(premiumFile)">저장</el-button>
  </div>
</template>

<script>
import imageOption from "@/mixins/imageOption";
import util from "@/mixins/util"
import elFileMixins from "@/mixins/elFileMixins";
import alertMixins from "@/mixins/alertMixins";
import awsS3FileUpload from "@/mixins/awsS3FileUpload";
import EventBus from "@/utils/event-bus";

export default {
  name: "PremiumFileComponent",
  mixins: [imageOption, elFileMixins, alertMixins, awsS3FileUpload],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{
      premiumFile: []
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {
    this.getFile();
  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
    getFile(){
      let params = {
        cid: 1,
        cty: 'premium_market'
      }
      this.$api.$file.getFile(params).then(res =>res.Data.Result).then(res => {
        // let premium =
        this.premiumFile = res.List
      })
    },
    hasFile(premium){
      // return !util.isEmpty(premium[0]) && !util.isEmpty(premium[0].a_idx)
      return !util.isEmpty(premium[0])
    },
    deleteImage(premium) {
      if (!this.hasFile(premium)) {
        return '';
      }
      this.deleteFiles.push(premium[0])
      this.premiumFile = []
    },
    checkFileValidator(file) {
      return !(util.isEmpty(file));
    },
    save(premium){
      if(!this.checkFileValidator(premium)){
        this.errorAlert('배너 이미지를 등록해주세요.')
        return false;
      }
      this.createConfirm({
        content: '저장하시겠습니까?',
        confirm: () => {
          this.writeFile(premium)
        }
      })
    },
    writeFile(premium){
      EventBus.$emit('changeLoading', true)
      let fileInfo = [
        {
          fileName: 'premiumFile',
          fileType: 'premium_market'
        },
      ]
      if(!util.isEmpty(this.deleteFiles)){
        this.runS3ApiDelete(this.deleteFiles, 0)
      }
      this.deleteFiles = [];

      this.runUploadFileInfo(fileInfo, 0, 1).then(res=>{
        if(res){
          this.getFile()
          this.createAlert({
            content: '저장되었습니다.'
          })
        }
      })
    },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>